module.exports = __webpack_public_path__ + "img/otp-phone.78e133b0.jpg";